module.exports = __webpack_public_path__ + "static/media/D-DINCondensed.8fc074e0.ttf";